import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import routes from '../../../../../../../Routes/routes';
import { PAYROLL_DETAIL_TABS, PAYROLL_USER_MODEL } from '../Model/Model';
import { GetEmployeeDetailsByUserId } from '../../../../../../../reduxToolkit/Employee/EmployeeApi';
import { ATTENDANCE_SUBVIEW_MODEL } from '../../../Model/Model';
import { permissionObj } from '../../../../../../../Helpers/permission';
import { MODELS } from '../../../../../../../Apis/Models';
import { TABLES } from '../../../../../../../Apis/Tables';
import {
    SEARCH_MODEL,
    DEFAULT_PAGINATION_START,
    DEFAULT_PAGINATION_LIST_SIZE,
} from '../../../../../../../components/table/Model/TableModel';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const PayrollUserDetailsApp = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const { payrollResultId, userId, currentTab, currentSubView, payrollHistoryFilters } = location?.state || {};
    const [activeTab, setActiveTab] = useState(PAYROLL_DETAIL_TABS.ACTIVE_PERIOD);
    const [userDetail, setUserDetail] = useState(null);

    useEffect(() => {
        if (!userId) return;
        dispatch(GetEmployeeDetailsByUserId(userId)).then(({ payload: { data: { data, success } } }) => {
            if (success) setUserDetail(PAYROLL_USER_MODEL.set(data));
        });
    }, [userId]);

    const goBack = () => {
        navigate(routes.attendance.main, {
            // The history sub-view is filtered by year and period, so both travel back
            // with the tab to rebuild the list the user came from.
            state: { currentTab, currentSubView, payrollHistoryFilters },
        });
    };

    // Export is only available on the active sub-view and requires its export permission.
    const isActiveSubView = currentSubView === ATTENDANCE_SUBVIEW_MODEL.PAYROLL.ACTIVE;
    const canExport = isActiveSubView && (DEV || permission?.includes(permissionObj?.WEB_PAYROLL_ACTIVE_EXPORT));

    // Build the export body scoped to this user, without the simple search key.
    const exportModuleId = MODELS.PAYROLL_USER_HISTORY;
    const exportOption = TABLES.PAYROLL_USER_HISTORY;
    const bodyForExport = SEARCH_MODEL.setObject({
        page: DEFAULT_PAGINATION_START,
        size: DEFAULT_PAGINATION_LIST_SIZE,
        model: exportOption,
        userId,
    });

    return {
        t,
        navigate,
        DEV,
        permission,
        goBack,
        activeTab,
        setActiveTab,
        userDetail,
        userId,
        payrollResultId,
        currentSubView,
        canExport,
        exportModuleId,
        exportOption,
        bodyForExport,
    };
};

export default PayrollUserDetailsApp;
